import { Input } from 'antd';
import styled from 'styled-components';

// Header search box from the "Top Navigation" Figma design (Form/Input, 240x48).
export const SearchInput = styled(Input)`
  &&.ant-input-affix-wrapper {
    width: 240px;
    height: 48px;
    padding: 4px 12px;
    border: 1px solid #ccdce4;
    border-radius: 16px;
    background: #ffffff;
  }

  &&.ant-input-affix-wrapper:hover,
  &&.ant-input-affix-wrapper-focused {
    border-color: #ccdce4;
  }

  /* Must outrank the 5-class page-header prefix rule in Common.less (10px margin, 40px height). */
  &&&&& .ant-input-prefix {
    height: auto;
    margin-inline-end: 0;
  }

  && .ant-input {
    padding: 0 8px;
    color: #525252;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
  }

  && .ant-input::placeholder {
    color: #525252;
    font-size: 16px;
    font-weight: 400;
  }
`;
